module.exports = __webpack_public_path__ + "img/footer.4feed8e9.png";